export const badgeVariantsSizeSmPx = "0.5rem";
export const badgeVariantsSizeSmItemSpacing = "0.25rem";
export const badgeVariantsSizeSmHeight = "1.5rem";
export const badgeVariantsSizeXsPx = "0.375rem";
export const badgeVariantsSizeXsItemSpacing = "0.188rem";
export const badgeVariantsSizeXsHeight = "1.25rem";
export const badgeVariantsSizeMdHeight = "2rem";
export const badgeVariantsSizeMdPx = "0.75rem";
export const badgeVariantsSizeMdItemSpacing = "0.375rem";
export const badgeVariantsSemanticBrandSurfaceDefault = "#e2f4f1";
export const badgeVariantsSemanticBrandOnSurfaceDefault = "#00857c";
export const badgeVariantsSemanticSuccessSurfaceDefault = "#e6f4ed";
export const badgeVariantsSemanticSuccessOnSurfaceDefault = "#1f8660";
export const badgeVariantsSemanticWarningSurfaceDefault = "#ffeee2";
export const badgeVariantsSemanticWarningOnSurfaceDefault = "#bf5a00";
export const badgeVariantsSemanticErrorSurfaceDefault = "#ffecea";
export const badgeVariantsSemanticErrorOnSurfaceDefault = "#cf484c";
export const badgeVariantsSemanticInfoSurfaceDefault = "#ecf1fb";
export const badgeVariantsSemanticInfoOnSurfaceDefault = "#4c74c9";
export const badgeVariantsSemanticNeutralSurfaceDefault = "#f1f1f1";
export const badgeVariantsSemanticNeutralOnSurfaceDefault = "#777777";
export const badgeSlotsLabelTypography = "400 0.75rem/1rem Inter";
export const badgeSlotsLabelFontWeight = "500";
export const badgeSlotsLabelResizingW = "resizing-w-hug";
export const badgeSlotsLabelResizingH = "resizing-h-hug";
export const badgeSlotsLeadingEmojiTypography = "400 1rem/1.5rem Inter";
export const badgeSlotsBaseBorderRadius = "0.5rem";
export const badgeSlotsBaseResizingW = "resizing-w-hug";
export const badgeSlotsBaseResizingH = "resizing-h-hug";
export const badgeSlotsLeadingIconDensity = "compact";
export const badgeSlotsLeadingIconSize = "16dp";
export const badgeSlotsLeadingIconGlyph = "fiber_manual_record";
export const badgeSlotsCloseIconDensity = "compact";
export const badgeSlotsCloseIconSize = "16dp";
export const badgeSlotsCloseIconGlyph = "close";
